import { HierarchyContextProps } from "./interface";

export const hierarchyInitialState: HierarchyContextProps = {
  id: "",
  accessRights: [],
  changed: false,
  hierarchyNodes: [],
  parentTemplates: {
    clinicalDatasets: [],
    clinicalCodeLists: [],
    clinicalValueLists: [],
    clinicalComments: [],
    clinicalMethods: [],
    clinicalWhereClauses: [],
    domainReplacements: [],
    lists: [],
    rowGroups: [],
    singles: [],
    analysisSets: [],
    dataSubsets: [],
    groupingFactors: [],
  },
  prefix: "",
  commentPanelStatus: {
    highlightCommentId: "",
    activeRelatedTo: "",
    showComments: false,
    commentFilter: "all",
  },
  doGetAccessRights: false,
  doSave: false,
  doTocSave: false,
  hierarchy: null,
  isClinicalLibraryLoading: false,
  isSubscribed: false,
  saveBlockers: { singles: new Set(), domainReplacements: new Set(), hierarchyName: undefined },
  savedHierarchy: null,
  tlfItemIndex: null,
  isNameChanged: false,
};
